function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { readFromDataTransfer as $7252cd45fc48c07c$export$d9e760437831f8b3, writeToDataTransfer as $7252cd45fc48c07c$export$f9c1490890ddd063 } from "./utils.module.js";
import { useEffectEvent as $9Tt78$useEffectEvent, chain as $9Tt78$chain } from "@react-aria/utils";
import { useRef as $9Tt78$useRef, useEffect as $9Tt78$useEffect } from "react";
import { useFocus as $9Tt78$useFocus } from "@react-aria/interactions";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $9fcc7f0d70d084ee$var$globalEvents = new Map();
function $9fcc7f0d70d084ee$var$addGlobalEventListener(event, fn) {
  var eventData = $9fcc7f0d70d084ee$var$globalEvents.get(event);
  if (!eventData) {
    var handlers = new Set();
    var listener = function listener(e) {
      var _iterator = _createForOfIteratorHelper(handlers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var handler = _step.value;
          handler(e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    eventData = {
      listener: listener,
      handlers: handlers
    };
    $9fcc7f0d70d084ee$var$globalEvents.set(event, eventData);
    document.addEventListener(event, listener);
  }
  eventData.handlers.add(fn);
  return function () {
    eventData.handlers.delete(fn);
    if (eventData.handlers.size === 0) {
      document.removeEventListener(event, eventData.listener);
      $9fcc7f0d70d084ee$var$globalEvents.delete(event);
    }
  };
}
function $9fcc7f0d70d084ee$export$2314ca2a3e892862(options) {
  var isDisabled = options.isDisabled;
  var isFocusedRef = (0, $9Tt78$useRef)(false);
  var _ref = (0, $9Tt78$useFocus)({
      onFocusChange: function onFocusChange(isFocused) {
        isFocusedRef.current = isFocused;
      }
    }),
    focusProps = _ref.focusProps;
  var onBeforeCopy = (0, $9Tt78$useEffectEvent)(function (e) {
    // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
    if (isFocusedRef.current && options.getItems) e.preventDefault();
  });
  var onCopy = (0, $9Tt78$useEffectEvent)(function (e) {
    var _options_onCopy;
    if (!isFocusedRef.current || !options.getItems) return;
    e.preventDefault();
    (0, $7252cd45fc48c07c$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    (_options_onCopy = options.onCopy) === null || _options_onCopy === void 0 ? void 0 : _options_onCopy.call(options);
  });
  var onBeforeCut = (0, $9Tt78$useEffectEvent)(function (e) {
    if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
  });
  var onCut = (0, $9Tt78$useEffectEvent)(function (e) {
    if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
    e.preventDefault();
    (0, $7252cd45fc48c07c$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    options.onCut();
  });
  var onBeforePaste = (0, $9Tt78$useEffectEvent)(function (e) {
    // Unfortunately, e.clipboardData.types is not available in this event so we always
    // have to enable the Paste menu item even if the type of data is unsupported.
    if (isFocusedRef.current && options.onPaste) e.preventDefault();
  });
  var onPaste = (0, $9Tt78$useEffectEvent)(function (e) {
    if (!isFocusedRef.current || !options.onPaste) return;
    e.preventDefault();
    var items = (0, $7252cd45fc48c07c$export$d9e760437831f8b3)(e.clipboardData);
    options.onPaste(items);
  });
  (0, $9Tt78$useEffect)(function () {
    if (isDisabled) return;
    return (0, $9Tt78$chain)($9fcc7f0d70d084ee$var$addGlobalEventListener('beforecopy', onBeforeCopy), $9fcc7f0d70d084ee$var$addGlobalEventListener('copy', onCopy), $9fcc7f0d70d084ee$var$addGlobalEventListener('beforecut', onBeforeCut), $9fcc7f0d70d084ee$var$addGlobalEventListener('cut', onCut), $9fcc7f0d70d084ee$var$addGlobalEventListener('beforepaste', onBeforePaste), $9fcc7f0d70d084ee$var$addGlobalEventListener('paste', onPaste));
  }, [isDisabled, onBeforeCopy, onCopy, onBeforeCut, onCut, onBeforePaste, onPaste]);
  return {
    clipboardProps: focusProps
  };
}
export { $9fcc7f0d70d084ee$export$2314ca2a3e892862 as useClipboard };